// 分各种环境，来配置不同的接口域名
// 生产域名
import wkReader from "../common/js/wkreader";
const PROTOCOL = location.protocol;
let baseUrl = `${PROTOCOL}//read.zhulang.com`

if (process.env.NODE_ENV === 'development') {
  // 开发域名
  // baseUrl = `${PROTOCOL}//read-dev.zhulang.com`
  baseUrl = `/api`
} else if (process.env.NODE_ENV === 'test') {
  // 测试域名
  baseUrl = `${PROTOCOL}//read-dev.zhulang.com`
} else if (process.env.NODE_ENV === 'pre') {
  // 188域名
  baseUrl = `${PROTOCOL}//test-readpay.zhulang.com`
}

// if (location.href.indexOf('nobase') == -1) {
//   wkReader.getHost((host) => {
//     console.log('从客户端获取到host' + host)
//     if (host) {
//       console.log('替换host')
//       baseUrl = host.replace('http:', PROTOCOL)
//     }

//     setTimeout(() => {
//       console.log('baseUrl', baseUrl)
//       console.log("当前H5地址" + window.location.href)
//     }, 1000);
//   })
// }



export default baseUrl



// WEBPACK FOOTER //
// ./src/api/baseUrl.js